<template functional>
  <div class="meta-league-info">
    <img
      v-if="props.categoryIcon"
      class="category-icon"
      :src="props.categoryIcon"
      loading="lazy"
    >
    <span>
      {{ props.category }} -
      <router-link
        :to="{
          name: 'matchList',
          params: { sportName: encodeURIComponent(props.sportName) },
          query: { t: props.tournamentId }
        }"
      >
        {{ props.tournament }}
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: String,
      default: ''
    },
    categoryIcon: {
      type: String,
      default: null
    },
    tournament: {
      type: String,
      default: ''
    },
    tournamentId: {
      type: String,
      default: ''
    },
    sportName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.meta-league-info {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 12px;
  line-height: 40px;
  .ellipsis();

  .category-icon {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
  }

  a {
    color: #fff;
    text-decoration: underline;
  }
}
</style>
